Promise = require 'bluebird'
React = require 'react'
t = require('views/internal/recup-with-helpers')('org_account')

module.exports = class extends React.Component
  onCancelClick: =>
    @props.onCancelClick()

  renderSection: t.renderable ->
    { joinRequest, onRequestClick, canChange, isAdmin, currentMember } = @props
    onCancelClick = @onCancelClick

    requestedByCurrentMember = joinRequest?.member.get('id') == currentMember.get('id')

    t.div '.setting-item-detail', =>
      t.div '.join-request-text', ->
        t.p ->
          if joinRequest?
            if requestedByCurrentMember
              t.format 'already-requested-by-current-user',
                enterpriseName: joinRequest.enterprise.get('displayName')
            else
              if joinRequest.enterprise?
                t.format 'already-requested',
                  enterpriseName: joinRequest.enterprise.get('displayName')
                  memberFullName: joinRequest.member.get('fullName')
              else
                t.format 'already-requested-no-enterprise-name',
                  memberFullName: joinRequest.member.get('fullName')
          else
            t.format 'request-enterprise-add'

        if !isAdmin
          t.div '.helper.u-float-left', ->
            t.format 'you-need-to-be-an-admin-to-change-this-setting'

    t.div '.setting-item-action', ->
      disabled = joinRequest? || !canChange

      classes =
        'button-link': true
        'u-text-align-center': true
        disabled: disabled

      t.b onRequestClick, disabled: disabled, class: t.classify(classes), ->
        t.format if joinRequest? then 'requested' else 'request'

      if joinRequest? && canChange
        t.a '.cancel-join-request.quiet', onClick: onCancelClick, ->
          t.format 'cancel-request'

  render: t.renderable ->
    { enterprise } = @props

    t.div '.window-module.u-clearfix', =>
      t.div '.window-module-title', ->
        t.h3 '.u-inline', ->
          t.format 'add-to-enterprise'
      t.div '.setting-item', =>
        if !enterprise?
          @renderSection()
        else
          t.div ->
            t.format 'already-belongs-to-enterprise',
              enterpriseName: enterprise.get('displayName')



// WEBPACK FOOTER //
// ./app/scripts/views/organization/add-to-enterprise-component.coffee